export default __webpack_public_path__ + "static/media/loading.a5303bf7.gif";